import { render, staticRenderFns } from "./pageElementImage.vue?vue&type=template&id=9ea789b8&scoped=true&"
import script from "./pageElementImage.vue?vue&type=script&lang=js&"
export * from "./pageElementImage.vue?vue&type=script&lang=js&"
import style0 from "./pageElementImage.vue?vue&type=style&index=0&id=9ea789b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea789b8",
  null
  
)

export default component.exports